import { weddingConfig } from '@/data/weddingConfig';
import ScrollReveal from '@/components/feature/ScrollReveal';

export default function Introduction() {
  return (
    <section className="relative flex min-h-[85svh] w-full items-center justify-center bg-background-50 py-20 md:min-h-[80svh] md:py-32">
      <div className="mx-auto max-w-2xl px-6 text-center">
        <ScrollReveal>
          <p className="font-heading text-xl italic leading-relaxed tracking-wide text-foreground-700 sm:text-2xl md:text-3xl md:leading-relaxed">
            “{weddingConfig.introductionText}”
          </p>
        </ScrollReveal>

        <ScrollReveal delay={1}>
          <p className="mx-auto mt-12 max-w-md font-body text-xs uppercase tracking-[0.2em] text-foreground-500 sm:text-sm">
            {weddingConfig.introductionSubtext}
          </p>
        </ScrollReveal>

        {/* Ornamental separator */}
        <ScrollReveal delay={2}>
          <div className="mt-14 flex items-center justify-center gap-4">
            <span className="h-px w-16 bg-primary-300" />
            <span className="h-1.5 w-1.5 rotate-45 bg-primary-400" />
            <span className="h-px w-16 bg-primary-300" />
          </div>
        </ScrollReveal>

        <ScrollReveal delay={3}>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-3 sm:gap-4">
            <span className="font-script text-3xl text-foreground-800 break-words sm:text-4xl md:text-5xl">
              {weddingConfig.brideName}
            </span>
            <span className="font-heading text-xl text-foreground-500 sm:text-2xl md:text-3xl">
              &
            </span>
            <span className="font-script text-3xl text-foreground-800 break-words sm:text-4xl md:text-5xl">
              {weddingConfig.groomName}
            </span>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}